import { ESTATE_SORTING_VALUES } from '../constants';

import type { SortConfigs } from '../types';

const beforeElementClasses =
  'whitespace-nowrap button relative before:content-[""] before:block before:absolute before:rounded-full before:-right-3 lg:before:-right-5 before:-translate-y-1/2 before:top-1/2 before:w-1 before:h-1 before:bg-black-500';

export const publicSortConfigs: SortConfigs = [
  {
    titles: {
      en: 'Lowest price first',
      ru: 'Сначала дешевле',
    },
    sortKey: ESTATE_SORTING_VALUES.CHEAPER,
    type: 'plain',
    className: beforeElementClasses,
    defaultSelected: true,
  },
  {
    titles: {
      en: 'Highest price first',
      ru: 'Дороже',
    },
    sortKey: ESTATE_SORTING_VALUES.EXPENSIVE,
    type: 'plain',
    className: beforeElementClasses,
  },
  {
    titles: {
      en: 'Most recent',
      ru: 'Новее',
    },
    sortKey: ESTATE_SORTING_VALUES.NEWER,
    type: 'plain',
  },
];
